import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppLoaderComponent } from './app-loader.component';

interface Config {
  width?: string
}

@Injectable()
export class AppLoaderService {
  public isLoading: boolean = false;
  public loaderText: string = '';

  dialogRef!: MatDialogRef<AppLoaderComponent>;


  constructor(private dialog: MatDialog) { }

  public open(title: string = 'Please wait', config: Config = { width: '100vw' }): Observable<boolean> {
    this.dialogRef = this.dialog.open(AppLoaderComponent, { disableClose: true, backdropClass: 'light-backdrop' });
    this.dialogRef.updateSize(config.width);
    this.dialogRef.componentInstance.title = title;
    return this.dialogRef.afterClosed();
  }

  /** show app loading...please wait message */
  public showLoading(): void {
    this.showLoader('Loading...please wait');
  }
  public hideLoading(): void {
    this.hideLoader();
  }

  /**
   * show custom loader
   * @param title
   */
  public showLoader(title: string): void {
    this.loaderText = title;

    // The setTimeout will fix ExpressionChangedAfterItHasBeenCheckedError when trying to get "isLoading" value in app.component.html for showing "app-loading-indicator"
    setTimeout(() => {
      this.isLoading = true;
    });
  }
  public hideLoader(): void {
    this.isLoading = false;
  }

  public showSaving(): void {
    this.showLoader('Saving...please wait');
  }
  public hideSaving(): void {
    this.hideLoader();
  }

  public close() {
    if (this.dialogRef)
      this.dialogRef.close();
  }
}
